import { render } from "./RobotStats.vue?vue&type=template&id=78677a30"
import script from "./RobotStats.vue?vue&type=script&lang=js"
export * from "./RobotStats.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__